/* ============================================================
   One bundle, two sites.

   teg.ojee.net is the system console for the disinteg box;
   storage.ojee.net is the NAS. They share a design system, a
   build and a hostname check — and nothing else. This file is
   only the fork in the road.
   ============================================================ */

import React, { useEffect } from 'react';
import './ojee-ui.css';
import './theme-teg.css';
import StorageApp from './storage/StorageApp';
import TegApp from './teg/TegApp';

function isStorageHost() {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  if (host === 'storage.ojee.net' || host.startsWith('storage.')) return true;
  const path = window.location.pathname;
  // A public share link belongs to storage whatever host it arrives on. It is
  // also the one route a stranger reaches, so sending them to the teg login
  // form would be the worst possible answer to a link someone sent them.
  if (/\/s\/[A-Za-z0-9_-]{20,64}\/?$/.test(path)) return true;
  // teg.ojee.net/storage works too, so the split can be tested without DNS.
  return path.replace(/\/+$/, '').endsWith('/storage');
}

export default function App() {
  const storage = isStorageHost();

  useEffect(() => {
    // The violet lives in a body class: storage keeps the system's cyan, and
    // the theme file redefines tokens only.
    document.body.classList.toggle('teg-theme', !storage);
    if (storage) return;
    document.title = 'teg · system';
    const set = (sel, attrs) => {
      let el = document.head.querySelector(sel);
      if (!el) { el = document.createElement(sel.startsWith('meta') ? 'meta' : 'link'); document.head.appendChild(el); }
      Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
    };
    set('link[rel="icon"]', { rel: 'icon', type: 'image/svg+xml', href: '/teg-icon.svg' });
    set('link[rel="apple-touch-icon"]', { rel: 'apple-touch-icon', href: '/teg-apple-touch-icon.png' });
    set('meta[name="theme-color"]', { name: 'theme-color', content: '#0c0712' });
  }, [storage]);

  return storage ? <StorageApp/> : <TegApp/>;
}
